module.exports = __webpack_public_path__ + "img/not-found.202e81e2.svg";